/* eslint-disable import/prefer-default-export */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { setNotification } from 'utils';
import { push } from 'react-router-redux';
import * as EmailTemplateActions from '../actions/emailTemplateActions';
import * as EmailTemplateApi from '../api/emailTemplateApi';
import * as EmailTemplateTypes from '../types/emailTemplateTypes';

const getLayout = state => state.layout;
const getEmailTemplate = state => state.emailTemplate;

// L O A D   E M A I L   T E M P L A T E
function* loadEmailTemplateSaga() {
    try {
        const emailTemplate = yield select(getEmailTemplate);
        const { offset, limit, filters, sort } = emailTemplate;
        const params = {
            offset,
            limit,
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const filterParams = {};

        if (filters.resellerShop !== undefined) {
            filterParams.reseller_id = filters.resellerShop;
        }

        if (filters.language !== undefined) {
            filterParams.language = filters.language;
        }

        if (filters.type !== undefined) {
            filterParams.type = filters.type;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield EmailTemplateApi.getEmailTemplateApi(params);

        if (result.status === 200) {
            yield put(EmailTemplateActions.loadEmailTemplateRes(result.data));
        } else {
            yield put(EmailTemplateActions.loadEmailTemplateErr());
        }
    } catch (e) {
        yield put(EmailTemplateActions.loadEmailTemplateErr());
        console.log(e);
    }
}

export function* loadEmailTemplateWatcher() {
    yield takeLatest(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE, loadEmailTemplateSaga);
}
// L O A D   E M A I L   T E M P L A T E

// L O A D   E D I T A B L E   E M A I L   T E M P L A T E
function* loadEditableEmailTemplateSaga(action) {
    try {
        const emailTemplate = yield select(getEmailTemplate);
        const { offset, limit } = emailTemplate;

        const params = {
            offset,
            limit,
        };

        params.filter = JSON.stringify({ _id: action.id });

        const result = yield EmailTemplateApi.getEmailTemplateApi(params);

        if (result.status === 200) {
            yield put(EmailTemplateActions.loadEditableEmailTemplateRes(result.data));
        } else {
            yield put(EmailTemplateActions.loadEditableEmailTemplateErr());
        }
    } catch (e) {
        yield put(EmailTemplateActions.loadEditableEmailTemplateErr());
        console.log(e);
    }
}

export function* loadEditableEmailTemplateWatcher() {
    yield takeLatest(EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE, loadEditableEmailTemplateSaga);
}
// L O A D   E D I T A B L E   E M A I L   T E M P L A T E

// E D I T   E M A I L   T E M P L A T E
function* editEmailTemplateSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;

        const result = yield EmailTemplateApi.editEmailTemplateApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'emailTemplates.notification.editEmailTemplate.success');

            yield put(EmailTemplateActions.editEmailTemplateRes());
            yield call(loadEmailTemplateSaga);
            yield put(push('/settings/email-templates'));
        } else {
            setNotification('error', locale, 'global.error', 'emailTemplates.notification.editEmailTemplate.error');
            yield put(EmailTemplateActions.editEmailTemplateErr());
        }
    } catch (e) {
        yield put(EmailTemplateActions.editEmailTemplateErr());
        console.log(e);
    }
}

export function* editEmailTemplateWatcher() {
    yield takeLatest(EmailTemplateTypes.EDIT_EMAIL_TEMPLATE, editEmailTemplateSaga);
}
// E D I T   E M A I L   T E M P L A T E


// A D D   E M A I L   T E M P L A T E
function* addEmailTemplateSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;

        const params = {
            offset: 0,
            limit: 1,
            filter: JSON.stringify({ type: action.data.type, language: action.data.language, reseller_id: action.data.reseller_id, source: action.data.source }),
        };

        const getRequestResult = yield EmailTemplateApi.getEmailTemplateApi(params);

        if (getRequestResult.status === 200 && getRequestResult.data?.total === 0) {
            const postRequestResult = yield EmailTemplateApi.addEmailTemplateApi(action.data);

            if (postRequestResult.status === 202) {
                setNotification('success', locale, 'global.success', 'emailTemplates.notification.addEmailTemplate.success');

                yield put(EmailTemplateActions.addEmailTemplateRes());
                yield call(loadEmailTemplateSaga);
                yield put(push('/settings/email-templates'));
            } else {
                setNotification('error', locale, 'global.error', 'emailTemplates.notification.addEmailTemplate.error');
                yield put(EmailTemplateActions.addEmailTemplateErr());
            }
        } else {
            setNotification('error', locale, 'global.error', 'emailTemplates.notification.alreadyExists.error');
            yield put(EmailTemplateActions.addEmailTemplateErr());
        }
    } catch (e) {
        yield put(EmailTemplateActions.addEmailTemplateErr());
        console.log(e);
    }
}

export function* addEmailTemplateWatcher() {
    yield takeLatest(EmailTemplateTypes.ADD_EMAIL_TEMPLATE, addEmailTemplateSaga);
}
// A D D   E M A I L   T E M P L A T E

// L O A D   E M A I L   T E M P L A T E   T A G S
function* loadEmailTemplateTagsSaga() {
    try {
        const result = yield EmailTemplateApi.getEmailTemplateTagsApi();

        if (result.status === 200) {
            yield put(EmailTemplateActions.loadEmailTemplateTagsRes(result.data));
        } else {
            yield put(EmailTemplateActions.loadEmailTemplateTagsErr());
        }
    } catch (e) {
        yield put(EmailTemplateActions.loadEmailTemplateTagsErr());
        console.log(e);
    }
}

export function* loadEmailTemplateTagsWatcher() {
    yield takeLatest(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS, loadEmailTemplateTagsSaga);
}
// L O A D   E M A I L   T E M P L A T E   T A G S
